import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {
  Box, Button, CardActions, // Stack,
} from '@mui/material';
import { TextField } from '@mui/material';
// import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
// import Visibility from '@mui/icons-material/Visibility';
// import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import TransitEnterexitRoundedIcon from '@mui/icons-material/TransitEnterexitRounded';

const examples = [
  { criteria: 'Market Cap  > 500 AND\nCost of Rev  > 200' },
  { criteria: 'Market Cap > 500 AND\nCost of Rev > 20 OR Net Inc Mgn  > 2' },
  { criteria: '2*PE + Rev 1Y Grw < 0.00002 AND\nROA > 1 OR ROA > 1' },
]

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`example-screen-${index}`}
      aria-labelledby={`example-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `example-tab-${index}`,
    'aria-controls': `example-screen-${index}`,
  };
}

export default function QueryExamples({ tryThisQuery }) {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event) => {
    event.preventDefault()
    // Update number using modulo operator (%) to reset to 0 when reaching 3
    const updatedNumber = (value + 1) % 3;
    setValue(updatedNumber);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const tryQuery = (event) => {
    event.preventDefault();
    tryThisQuery(examples[value]?.criteria)
  }

  return (
    <Card sx={{
      maxWidth: { md: 477, sm: 345, xs: '100%' }, boxShadow: 0, background: '#f8f9fa', border: '1px solid #eae9ee',
      '.MuiInputBase-root.MuiInput-root:after': { borderBottom: '0 !important' },
      '.MuiInputBase-root.MuiInput-root:before': { borderBottom: '0 !important' }, p: 0,
      '& .swipe-tab': { minWidth: 470, overflow: 'auto', mx: 2 },
      '& .MuiButton-startIcon': { m: 0 }, borderRadius: '8px', mb: 3,
      '& .MuiTextField-root': { width: '90%', m: 0 }
    }}>
      <CardContent sx={{ px: 0, }}>
        <Typography gutterBottom variant="h6" component="div" sx={{ ml: 2, fontSize: '1rem' }}>
          Start your first query:
        </Typography>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          {/* <Stack direction="row" sx={{ minWidth: '100%'}} > */}
          {/* <IconButton aria-label="previous" sx={{ position: 'absolute' }}><ChevronLeftRoundedIcon /></IconButton> */}
          <Box
            className="swipe-tab"
          >
            {examples && examples.length > 0 ? examples?.map((d, i) => {
              return (
                <TabPanel value={value} index={i} dir={theme.direction}>
                  <TextField
                    InputProps={{ readOnly: true, }} sx={{ '& textarea': { color: '#1d1d1f !important', fontSize: '.875rem' } }}
                    id="example" multiline variant="standard" size='medium' fullWidth
                    value={d.criteria}
                  />
                </TabPanel>)
            }) : null}
            {/* <TabPanel value={value} index={1} dir={theme.direction}>
            <TextField
              InputProps={{ readOnly: true, }}
              id="example" multiline variant="standard" size='medium' fullWidth
              value={`Market Cap > 500 AND\nCost of Revenue > 20 AND\nNet Income Margin TTM > 2\nNet Income Margin TTM > 2`}
            />
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <TextField
              InputProps={{ readOnly: true, }}
              id="example" multiline variant="standard" size='medium' fullWidth
              value={`Market Cap > 500 AND\nCost of Revenue > 20 AND\nNet Income Margin TTM > 2\nNet Income Margin TTM > 2`}
            />
          </TabPanel> */}
          </Box>
          <Box sx={{ position: 'absolute', right: 0, mr: 1 }}>
            <IconButton onClick={handleChange} aria-label="next" ><ChevronRightRoundedIcon /></IconButton>
          </Box>
        </Box>
        {/* </Stack> */}
        {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 3, }} >
          {[...Array(3)].map((_, index) => <Box key={index} sx={{ borderRadius: '50%', width: `max(${index > 0 ? 5 : 6}px, 3px)`, height: `max(${index > 0 ? 5 : 6}px, 3px)`, bgcolor: index === 0 ? '#174c86' : '#999', }} />)}
        </Box> */}
      </CardContent>
      <CardActions sx={{ justifyContent: 'space-between' }}>
        {/* <Button size="small"
          sx={{ textAlign: 'left', textTransform: "none", color: '#174ea6' }}
          href='/stock-screener/guide'
        >
          View detailed guide for creating screens
        </Button> */}
        <Button disableElevation size="small" variant="contained"
          // startIcon={<TransitEnterexitRoundedIcon sx={{ mr: 1 }} />}
          sx={{ textTransform: "none", }}
          onClick={tryQuery}
        >
          Give this query a try
        </Button>
      </CardActions>
    </Card>
  );
}
